import { defineMessages } from 'react-intl';

export default {
  home: {
    messages: defineMessages({
      name: {
        id: 'footer.home.title',
        defaultMessage: 'Home',
      },
    }),
    url: '/',
  },
  about: {
    messages: defineMessages({
      name: {
        id: 'footer.about.title',
        defaultMessage: 'About Us',
      },
    }),
    url: '/about-us',
  },
  pathways: {
    messages: defineMessages({
      name: {
        id: 'footer.pathways.title',
        defaultMessage: 'Pathways & Pricing',
      },
    }),
    url: '#',
  },
  faq: {
    messages: defineMessages({
      name: {
        id: 'footer.faq.title',
        defaultMessage: 'FAQ',
      },
    }),
    url: '/faq',
  },
  assessment: {
    messages: defineMessages({
      name: {
        id: 'footer.assessment.title',
        defaultMessage: 'Assessment',
      },
    }),
    url: '#',
  },
  contact: {
    messages: defineMessages({
      name: {
        id: 'footer.contact.title',
        defaultMessage: 'Contact Us',
      },
    }),
    url: '/contact-us',
  },
  privacy: {
    messages: defineMessages({
      name: {
        id: 'footer.privacy.title',
        defaultMessage: 'Privacy Policy',
      },
    }),
    url: 'https://www.np.edu.sg/Pages/privacy.aspx',
  },
};



// WEBPACK FOOTER //
// ./src/ui/app/layout/footer/messages.js